import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Pool} from '@docma-mm-core/pool/pool';

export interface ICreatePoolPayload {
  Name: string;
  Comment: string;
  IsPublic: boolean;
  VisibleFor: number;
  Faults?: number[];
}

export interface IUpdatePoolPayload {
  Name: string;
  Comment: string;
  IsPublic: boolean;
  VisibleFor: number;
  Faults?: number[];
}

export interface IPoolDefect {
  Id: number;
  SUid: string;
  UniqueId: string;
}

export interface IPoolSearchResult {
  Id: number;
  Count: number;
}

export interface IPoolSearchResponse {
  Data: IPoolSearchResult[];
  Count: number;
}

@Injectable()
export class PoolApiService extends BasedataService {

  private projectUrl = '/projects/';
  private poolUrl = 'pools';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectPoolUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + '/' + this.poolUrl);
  }

  private getProjectPoolByIdUrl(projectId: number, poolId: number) {
    return super.getFullUrl(this.projectUrl + projectId + '/' + this.poolUrl + '/' + poolId);
  }

  createProjectPool(projectId: number, pool: ICreatePoolPayload) {
    const url = this.getProjectPoolUrl(projectId);
    return this.http.post<Pool>(url, pool, {headers: this.getHeaders()});
  }

  updateProjectPool(projectId: number, poolId: number, pool: IUpdatePoolPayload) {
    const url = super.getFullUrl(`/pools/${poolId}`);
    return this.http.put(url, pool, {headers: this.getHeaders()});
  }

  deleteProjectPool(projectId: number, poolId: number) {
    const url = super.getFullUrl(`/pools/${poolId}`);
    return this.http.delete(url, {headers: this.getHeaders()});
  }

  addDefectsToPool(projectId: number, poolId: number, defects: IPoolDefect[]) {
    const url = super.getFullUrl(`/projects/${projectId}/pools${poolId}/defects`);
    return this.http.post(url, defects, {headers: this.getHeaders()});
  }

  removeDefectsFromPool(projectId: number, poolId: number, defects: IPoolDefect[]) {
    const url = super.getFullUrl(`/projects/${projectId}/pools${poolId}/defects`);
    return this.http.delete(url, {
      headers: this.getHeaders(),
      body: defects
    });
  }

  getPoolsWithUpdatedCounts(projectId: number, poolIds: number[]): Observable<IPoolSearchResponse> {
    const url = super.getFullUrl(`/projects/${projectId}/pools/search`);
    const params = new HttpParams().set('$details', '10');

    return this.http.post<IPoolSearchResponse>(url, poolIds, {
      headers: this.getHeaders(),
      params: params
    });
  }
}
